<section class="container block">

    @if (data.alias === 'video') {
        <app-youtube-player
            [videoId]="data.videoId"
            [thumbnail]="data.thumbnail"
            [autoplay]="data.autoplay"
            [caption]="data.videoCaption"
        ></app-youtube-player>
    } @else if (data.alias === 'vimeoVideo') {
        <app-vimeo-player
            [videoId]="data.videoId"
            [thumbnail]="data.thumbnail"
            [autoplay]="data.autoplay"
            [caption]="data.videoCaption">
        </app-vimeo-player>
    }
</section>
